import { useEffect } from "react";
import { useDispatch } from "react-redux";

import ACTION from "../store/action";
import { readColumnLayoutFromSession } from "../utils/columnLayout";

// The column resize/reorder hook only persists layout to sessionStorage, which is not
// reactive. In a saved-list view this mirrors the live layout into the store on every
// change so the "unsaved changes" selectors (and the Save button) can react to it.
// The table re-renders whenever the resize/reorder hook mutates its state, so reading
// sessionStorage here picks up the fresh layout.
const useTrackSavedListLayout = (isFilterListView, columnLayoutKey) => {
  const dispatch = useDispatch();
  const layout = isFilterListView && columnLayoutKey ? readColumnLayoutFromSession(columnLayoutKey) : null;
  // `layout` is a fresh object every render, so its serialized form is the stable
  // change-trigger for the effect below.
  const serializedLayout = layout ? JSON.stringify(layout) : null;

  useEffect(() => {
    if (layout) {
      dispatch(ACTION.setTableLayout(layout));
    }
  }, [serializedLayout, dispatch]);
};

export default useTrackSavedListLayout;
